import { FieldCounts } from '@cibo/core'

export function fieldCountsToColor(fieldCounts: FieldCounts) {
  if (fieldCounts.total === 0) {
    return undefined
  }
  if (fieldCounts.incomplete > 0) {
    return 'warning'
  }
  if (fieldCounts.pass > 0) {
    return 'success'
  }
  return 'error'
}
